export const INPUT_CLASS =
  'min-h-11 w-full rounded-field border border-field bg-card px-3 text-sm text-ink placeholder:text-muted disabled:opacity-60 aria-[invalid=true]:border-debit';
